import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './FeaturesSection.module.css';

export default function FeaturesSection() {
  const { t } = useTranslation('landing');

  const SIDE_FEATURES: Array<{ title: string; description: string; icon: ReactNode }> = [
    {
      title: t('features.guidedSessions.title'),
      description: t('features.guidedSessions.description'),
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round">
          <circle cx="12" cy="12" r="9" />
          <path d="M10 8.5l5 3.5-5 3.5V8.5z" fill="currentColor" stroke="none" />
        </svg>
      ),
    },
    {
      title: t('features.moodTracking.title'),
      description: t('features.moodTracking.description'),
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
        </svg>
      ),
    },
    {
      title: t('features.achievements.title'),
      description: t('features.achievements.description'),
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="8" r="6" />
          <path d="M8.56 14.31L6 22l6-3 6 3-2.56-7.69" />
        </svg>
      ),
    },
  ];

  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <header className={styles.header}>
          <h2 className={styles.heading}>{t('features.heading')}</h2>
          <p className={styles.subtitle}>
            {t('features.subtitle')}
          </p>
        </header>

        <div className={styles.bento}>
          <div className={styles.hero}>
            <svg className={styles.heroIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            </svg>
            <h3 className={styles.heroTitle}>{t('features.breathworkLibrary.title')}</h3>
            <p className={styles.heroDesc}>
              {t('features.breathworkLibrary.description')}
            </p>
            <p className={styles.stat}>{t('features.breathworkLibrary.stat')}</p>
          </div>

          <ul className={styles.sideList} role="list">
            {SIDE_FEATURES.map((f) => (
              <li key={f.title} className={styles.sideItem}>
                <div className={styles.sideItemHeader}>
                  <span className={styles.sideIcon}>{f.icon}</span>
                  <h3 className={styles.sideTitle}>{f.title}</h3>
                </div>
                <p className={styles.sideDesc}>{f.description}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
